import * as React from "react";
import { FormGroup } from "../RightAsideHelpers";
import { WorkflowNode } from "../../types";

interface Props {
  node: WorkflowNode;
  onUpdate: (node: Partial<WorkflowNode>) => void;
}

export default function TimeDelayEditor({ node, onUpdate }: Props) {
  const seconds = node.delaySeconds ?? 60;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = parseInt(e.target.value, 10);
    onUpdate({ delaySeconds: isNaN(val) || val < 1 ? 1 : val });
  };

  return (
    <>
      <FormGroup
        label="Delay (seconds)"
        tooltipText="Workflow execution pauses for this many seconds before continuing to the next step."
      >
        <input
          type="number"
          min={1}
          max={86400}
          className="input w-full"
          value={seconds}
          onChange={handleChange}
        />
      </FormGroup>
      <p className="text-xs text-slate-400 mt-1">
        Between 1 second and 86,400 seconds (24 hours).
      </p>
    </>
  );
}
